/**
 * Function for returning .sort() rules for case insensitive, localized sorting
 */
export default function lowerLocaleSort() {
    return (a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}
